"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// third party
var dayjs_1 = __importStar(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
var advancedFormat_1 = __importDefault(require("dayjs/plugin/advancedFormat"));
(0, dayjs_1.extend)(utc_1.default);
(0, dayjs_1.extend)(timezone_1.default);
(0, dayjs_1.extend)(advancedFormat_1.default);
function useDates() {
    var format = (0, react_1.useCallback)(function (date, outputFormat, isUtc) {
        if (outputFormat === void 0) { outputFormat = "MM/DD/YYYY"; }
        if (isUtc === void 0) { isUtc = false; }
        return isUtc
            ? dayjs_1.default.utc(date).tz(dayjs_1.default.tz.guess()).format(outputFormat)
            : (0, dayjs_1.default)(date).format(outputFormat);
    }, []);
    var formatTimezone = (0, react_1.useCallback)(function (date, zone, outputFormat) {
        if (outputFormat === void 0) { outputFormat = "ha"; }
        return dayjs_1.default.utc(date).tz(zone).format(outputFormat);
    }, []);
    var isAfter = (0, react_1.useCallback)(function (date, isUtc) {
        if (isUtc === void 0) { isUtc = false; }
        return (0, dayjs_1.default)().isAfter(isUtc ? dayjs_1.default.utc(date) : (0, dayjs_1.default)(date));
    }, []);
    return {
        format: format,
        formatTimezone: formatTimezone,
        isAfter: isAfter,
    };
}
exports.default = useDates;
//# sourceMappingURL=index.js.map